export const mkSelectFilterOption = (searchValue, inputValue) => searchValue.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
